import {runOnPage} from './general.js';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

runOnPage('case-study-default', () => {
	$(window).on('load', function () {
		if (window.location.hash === '#tech-we-use') {
			const $el = $('#tech-we-use');
			if ($el.length) {
				setTimeout(function () {
					$el[0].scrollIntoView({ behavior: 'smooth' });
				}, 50);
			}
		}
	});
});

runOnPage('case-study-detail', () => {
	$(function () {
		const video = $('#hero-video')[0];
		if (!video) return;

		const portraitURL  = '{control fileUrl, awsFile: $caseStudyEntity->videoPortrait, required: false}';
		const landscapeURL = '{control fileUrl, awsFile: $caseStudyEntity->videoLandscape, required: false}';
		const defaultURL   = '{control fileUrl, awsFile: $caseStudyEntity->videoDefault,   required: false}';

		const w = window.innerWidth;
		let expected = defaultURL;
		if (w <= 720)       expected = portraitURL;
		else if (w >= 1921) expected = landscapeURL;

		if (video.currentSrc.includes(expected)) {
			video.play().catch(() => {});
			return;
		}

		video.style.visibility = 'hidden';

		const showAndPlay = () => {
			video.removeEventListener('loadeddata', showAndPlay);
			video.style.visibility = '';
			video.play().catch(() => {});
		};

		video.addEventListener('loadeddata', showAndPlay);
		video.pause();
		video.load();
	});
});
